import React from 'react';

const BookingButton = ({ text = "Book Appointment", className = "" }) => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-booking');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <button
      onClick={scrollToContact}
      className={`bg-accent-magenta text-white px-8 py-4 rounded-full font-semibold hover:bg-accent-magenta/90 transition-all duration-200 shadow-lg ${className}`}
    >
      {text}
    </button>
  );
};

export default BookingButton;